import { Inject } from "inversify-props";
import { RegraFiscal } from "@/models/fiscal/RegrasFiscais";
import type { RegrasFiscaisServiceAdapter } from "./adapter/RegrasFiscaisServiceAdapter";

export class RegrasFiscaisUseCase {

	@Inject('RegrasFiscaisServiceAdapter')
	private regrasFiscaisServiceAdapter!: RegrasFiscaisServiceAdapter

	findRegrasFiscais = async (): Promise<RegraFiscal[]> =>
		await this.regrasFiscaisServiceAdapter.findRegrasFiscais()

	deleteRegraFiscal = async (regraFiscal: RegraFiscal): Promise<void> =>
		await this.regrasFiscaisServiceAdapter.deleteRegrasFiscais(regraFiscal)

	saveRegrasFiscais = async (regraFiscal: RegraFiscal): Promise<void> =>
		await this.regrasFiscaisServiceAdapter.saveRegrasFiscais(regraFiscal)
}